<script>
    import { toastMsg } from "../stores.js";

    $toastMsg = "";

    function animEnd(div) {
        div.addEventListener("animationend", () => {
            $toastMsg = "";
        });
    }

</script>

{#if $toastMsg}
    <div class="container">
        <div class="toast" use:animEnd>{$toastMsg}</div>
    </div>
{/if}

<style>
    .container {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        z-index: 10;
    }
    .toast {
        text-align: center;
        color: white;
        font-size: 18px;
        background: #666666;
        min-width: 180px;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 4px;
        opacity: 0;
        visibility: hidden;
        transform: translateY(50px);
        animation: toastAnim 3s ease-out;
    }

    @keyframes toastAnim {
        from {
            visibility: visible;
            opacity: 0;
            transform: translateY(50px);
        }

        15% {
            opacity: 1;
            transform: translateY(-30px);
        }

        85% {
            opacity: 1;
            transform: translateY(-30px);
        }

        99% {
            opacity: 0;
            transform: translateY(-40px);
        }

        to {
            visibility: hidden;
            transform: translateY(-60px);
        }
    }

</style>
